import { ResultKind, SmartSearchSelectOption } from '@/components/SmartSearch';

import { getElectrolyteBaseUrl } from '../urls';
import i18n from '@/i18n';

export const getSearchableActions = (): SmartSearchSelectOption[] => {
  const electrolyteBaseUrl = getElectrolyteBaseUrl();

  return [
    {
      kind: ResultKind.ACTION,
      title: i18n.t('common:constants.smartSearch.actions.addNewEmployee'),
      url: `${electrolyteBaseUrl}/onboardings/new`,
    },
    {
      kind: ResultKind.ACTION,
      title: i18n.t('common:constants.smartSearch.actions.addNewGroup'),
      url: `${electrolyteBaseUrl}/groups/new`,
    },
    {
      kind: ResultKind.ACTION,
      title: i18n.t('common:constants.smartSearch.actions.addApplication'),
      url: `${electrolyteBaseUrl}/applications?new=true`,
    },
  ];
};
